import "~/libs/sentry.lib";
import "~/libs/posthog.lib";

import * as Sentry from "@sentry/react";
import { StartClient } from "@tanstack/react-start/client";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";

import { logger } from "~/libs/logger";
import { gcRunArrowByAge } from "~/workers/opfs-dataset-cache";

// Prune stale run payloads before anything registers one. Fire-and-forget: a
// failed sweep only costs disk, so it must never block hydration.
void gcRunArrowByAge().catch((err) => {
  logger.debug({ err }, "run payload cache sweep failed");
});

hydrateRoot(
  document,
  <StrictMode>
    <StartClient />
  </StrictMode>,
  {
    // Custom handlers replace React's default console logging — log in dev so errors are visible
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      if (import.meta.env.DEV)
        console.error("Uncaught error", error, errorInfo?.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      if (import.meta.env.DEV)
        console.error("Caught error", error, errorInfo?.componentStack);
    }),
    onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
      if (import.meta.env.DEV)
        console.error("Recoverable error", error, errorInfo?.componentStack);
    }),
  },
);
